export const childCareKeyPrefix =
  'descriptions.admin-portal.events.details.child-care';
export const childCareTableKeyPrefix = childCareKeyPrefix.concat('.table');
export const childCareActionsKeyPrefix = childCareKeyPrefix.concat('.actions');
